export default __webpack_public_path__ + "static/media/logo-main.32e1c9c4.svg";